module.exports = __webpack_public_path__ + "static/heavy_royal3-b0ea009d192d0bce313c576898eb32eb.jpg";